import React from "react";

function Preloader() {
  return (
    <div id='preloader'>
      <div className='preloader-container'>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Preloader;
